import React from 'react';
import RenderError from '../../components/RenderError';
import CurrencyInput from 'react-currency-input-field';

function AdditionalBasicInfoFields({
  two,
  unit,
  handleInputChange,
  handleCurrencyInputChange,
  equipmentType,
  formData,
  setFormData,
  errors
}) {
  const typeOfSites = [
    'Poultry building',
    'Swine building',
    'Barn Greenhouse',
    'Other'
  ];

  return (
    <>
      <div className="form__field form__field--required">
        <label
          className="form__label u--margin-right-20 u--margin-bottom-0"
          htmlFor="typeOfSite"
        >
          At what type of site will the propane-fueled heating system be used?
        </label>
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError error={errors[`${equipmentType}_${unit}`].fuelType} />
        )}
        {typeOfSites.map((type) => (
          <label className="form__radio" key={type}>
            <input
              type="radio"
              name={`typeOfSite${two ? '2' : '1'}`}
              value={type}
              checked={
                two
                  ? formData.unitTwo.typeOfSite2 === type
                    ? 'checked'
                    : ''
                  : formData.unitOne.typeOfSite1 === type
                  ? 'checked'
                  : ''
              }
              onChange={(event) => handleInputChange(event, two)}
            />
            {type}
          </label>
        ))}
      </div>
      <div className="form__field form__field--required">
        <label className="form__label u--margin-right-20" htmlFor="engineSize">
          How many square feet is the building that the heating system will
          service?
        </label>
        <CurrencyInput
          name="buildingSquareFeet"
          className="form__input form__input--lg"
          value={
            formData[unit].buildingSquareFeet !== null &&
            formData[unit].buildingSquareFeet !== undefined
              ? parseInt(formData[unit].buildingSquareFeet)
              : 0
          }
          min={0}
          onValueChange={(value, name) =>
            handleCurrencyInputChange(name, value, two)
          }
          allowNegativeValue={false}
        />
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError
            error={errors[`${equipmentType}_${unit}`].buildingSquareFeet}
          />
        )}
      </div>
      <div className="form__field form__field--required">
        <label className="form__label u--margin-right-20" htmlFor="engineSize">
          How many weeks per year does your site require heat?
        </label>
        <input
          type="number"
          name="weeksOfHeatPerYear"
          value={formData[unit].weeksOfHeatPerYear}
          className="form__input form__input--lg"
          onChange={(event) => handleInputChange(event, two)}
        />
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError
            error={errors[`${equipmentType}_${unit}`].weeksOfHeatPerYear}
          />
        )}
      </div>
      <div className="form__field form__field--required">
        <label className="form__label u--margin-right-20" htmlFor="engineSize">
          At what temperature (degrees Fahrenheit) do you keep the installation
          building?
        </label>
        <input
          type="number"
          name="buildingTemperature"
          value={formData[unit].buildingTemperature}
          className="form__input form__input--lg"
          onChange={(event) => handleInputChange(event, two)}
        />
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError
            error={errors[`${equipmentType}_${unit}`].buildingTemperature}
          />
        )}
      </div>
      <div className="form__field form__field--required">
        <label
          className="form__label u--margin-right-20 u--margin-bottom-0"
          htmlFor="connectedToGrid"
        >
          Is this installation site connected to the electric grid?
        </label>
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError error={errors[`${equipmentType}_${unit}`].fuelType} />
        )}
        {['Yes', 'No'].map((choice) => (
          <label className="form__radio" key={choice}>
            <input
              type="radio"
              name={`connectedToGrid${two ? '2' : '1'}`}
              value={choice}
              checked={
                two
                  ? formData.unitTwo.connectedToGrid2 === choice
                    ? 'checked'
                    : ''
                  : formData.unitOne.connectedToGrid1 === choice
                  ? 'checked'
                  : ''
              }
              onChange={(event) => handleInputChange(event, two)}
            />
            {choice}
          </label>
        ))}
      </div>
    </>
  );
}

export default AdditionalBasicInfoFields;
